module.exports = __webpack_public_path__ + "static/media/3C.de347efd.jpg";